import React, { Fragment } from "react";
import Cookie from "js-cookie";
import { Form, Col } from "react-bootstrap";

import { SimilarAddresses, validateForm } from "./helpers";

const OtherAddresses = ({
  handleValidate,
  errors,
  formValues,
  setFormValues,
  otherAddressValues,
  otherAddressFields,
  addressIndex,
  disableFields,
}) => {
  const otherAddressFieldChange = (e, addressType, fieldId, setFormValues) => {
    e.persist();
    setFormValues((state) => {
      const prevValue = [...state.otherAddress];
      let otherAddress = [...state.otherAddress];
      otherAddress.splice(addressIndex, 1, "");
      otherAddress = otherAddress.filter((item) => item !== "");
      otherAddress.splice(addressIndex, 0, {
        ...prevValue[addressIndex],
        [fieldId]:
          fieldId === "state" || fieldId === "country"
            ? e.target.value.toUpperCase()
            : e.target.value,
          email: Cookie.get("email").toLowerCase(),
      });

      return {
        ...state,
        otherAddress,
        valuesChanged:
          prevValue[addressIndex][fieldId] === e.target.value ? false : true,
      };
    });
  };

  const autoCompleteFieldChange = (e, props) => {
    otherAddressFieldChange(e, null, props.field.fieldId, props.setFormValues);
  };

  const onSelectAddress = (selectedAddress, props) => {
    setFormValues((state) => {
      const prevValue = [...state.otherAddress];

      let otherAddress = [...state.otherAddress];
      otherAddress.splice(addressIndex, 1, "");
      otherAddress = otherAddress.filter((item) => item !== "");
      otherAddress.splice(addressIndex, 0, {
        ...prevValue[addressIndex],
        ...selectedAddress,
        email: Cookie.get("email").toLowerCase(),
      });

      props.addressFields.forEach(({ fieldId, key }) => {
        otherAddress[addressIndex][fieldId] && delete state.errors[key];
      });

      return {
        ...state,
        otherAddress,
        validForm: validateForm({ ...state, otherAddress }),
      };
    });
  };

  return otherAddressFields(addressIndex).map((addressField, index) => {
    return (
      <Fragment key={`otherAddressFragment${index}`}>
        {index === 0 && (
          <Form.Row key={`otherAddressContainer${index}`}>
            <Form.Group as={Col} md={4}>
              <Form.Label
                key={`otherAddressLabel${index}`}
                id="otherAddressTypeLabel"
                htmlFor={`addressSubType_${index}`}
                style={{ color: "black", fontWeight: "500" }}
              >
                Address Type
                <span className="required">*</span>
              </Form.Label>
              <Form.Control
                key={`addressSubType_${index}`}
                id="otherAddressType"
                name={`addressSubType_other${index}`}
                placeholder="Enter Address Type"
                autoComplete="addressSubType"
                type="text"
                disabled={disableFields}
                maxLength={20}
                onBlur={() =>
                  handleValidate(
                    {
                      field: {
                        fieldId: "addressSubType",
                        key: `addressSubType_other${addressIndex}`,
                      },
                      fieldValue: otherAddressValues["addressSubType"] || "",
                    },
                    setFormValues
                  )
                }
                onChange={(e) => {
                  handleValidate(
                    {
                      field: {
                        fieldId: "addressSubType",
                        key: `addressSubType_other${addressIndex}`,
                      },
                      fieldValue: e.target.value,
                    },
                    setFormValues
                  )
                  otherAddressFieldChange(
                    e,
                    null,
                    "addressSubType",
                    setFormValues
                  )
                }}
                value={otherAddressValues["addressSubType"] || ""}
              />
              {errors && errors[`addressSubType_other${addressIndex}`] && (
                <div style={{ color: "#d64a4a" }}>
                  {errors[`addressSubType_other${addressIndex}`]}
                </div>
              )}
            </Form.Group>
          </Form.Row>
        )}

        <Form.Row key={`otherAddress${index}`}>
          <SimilarAddresses
            handleValidate={handleValidate}
            errors={errors}
            address={addressField}
            formValues={formValues}
            fieldValueObject={otherAddressValues}
            setFormValues={setFormValues}
            onChange={otherAddressFieldChange}
            onAutoCompleteChange={autoCompleteFieldChange}
            onSelectAddress={onSelectAddress}
            disableFields={disableFields}
          />
        </Form.Row>
      </Fragment>
    );
  });
};

export default OtherAddresses;
